import { render, staticRenderFns } from "./worldCup.vue?vue&type=template&id=261a5c2f"
import script from "./worldCup.vue?vue&type=script&lang=js"
export * from "./worldCup.vue?vue&type=script&lang=js"
import style0 from "./worldCup.vue?vue&type=style&index=0&id=261a5c2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports